import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class E5peterExampleLibService {

  constructor() { }
}
